export default __webpack_public_path__ + "static/media/Rampver_SelfieHoldingId_Man_WomanGIF_1.60e446fc.gif";